var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{staticClass:"modal-saved-style",attrs:{"id":"saved-modal","is-show-header":false,"is-close-out-side":false,"container":"#saved-modal","width":"350"}},[_c('div',{staticClass:"saved-message"},[_vm._v("Your style has been saved")])])}
var staticRenderFns = []

export { render, staticRenderFns }